import type { VfConfig } from '#types/config/components/vf'

export default {
  brandClasses: {
    container: 'bg-grey-90 flex gap-1 relative p-4 items-center',
    message: 'text-sm c-grey-10',
    messageError: 'c-red-30',
  },
  iconSize: 'md'
} satisfies VfConfig['notification']
